import { IUserData } from '@/models';
import { ISalesRepService } from './sales-rep.types';
import { AxiosInstance } from 'axios';

export class SalesRepService implements ISalesRepService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/sales-reps/';
  }

  fetchSalesReps(): Promise<IUserData[]> {
    return this.axios
      .get<IUserData[]>(`${this.endpoint}`)
      .then(({ data }) => data);
  }

  fetchSalesRep(id: number): Promise<IUserData> {
    return this.axios
      .get<IUserData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }
}
